// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdateInventory,
    UpdatePrice,
} from "@insite/client-framework/Store/Pages/StaticList/Handlers/UpdateUnitOfMeasure";

export const xUpdatePrice: typeof UpdatePrice = props => {
    // const awaitableLoadRealTimePricing = makeHandlerChainAwaitable<
    //     Parameters<typeof loadRealTimePricing>[0],
    //     RealTimePricingModel
    // >(loadRealTimePricing);
    // const parameter = {
    //     productPriceParameters: [
    //         {
    //             productId: props.productInfo.productId,
    //             unitOfMeasure: props.parameter.unitOfMeasure,
    //             qtyOrdered: props.productInfo.qtyOrdered,
    //         },
    //     ],
    // };
    // const realTimePricingModel = await awaitableLoadRealTimePricing(parameter)(props.dispatch, props.getState);
    // props.pricing = realTimePricingModel.realTimePricingResults?.find(o => o.productId === props.productInfo.productId);
    props.pricing = props.productInfo?.pricing;
};

export const xUpdateInventory: typeof UpdateInventory = props => {
    // const awaitableLoadRealTimeInventory = makeHandlerChainAwaitable<
    //     Parameters<typeof loadRealTimeInventory>[0],
    //     RealTimeInventoryModel
    // >(loadRealTimeInventory);
    // const realTimeInventoryModel = await awaitableLoadRealTimeInventory({
    //     productIds: [props.productInfo.productId],
    // })(props.dispatch, props.getState);
    // props.inventory = realTimeInventoryModel.realTimeInventoryResults?.find(
    //     o => o.productId === props.productInfo.productId,
    // );
    props.inventory = props.productInfo?.inventory;
};

replaceInChain(chain, UpdatePrice, xUpdatePrice);
replaceInChain(chain, UpdateInventory, xUpdateInventory);
